// Import Components - Barrel exports
export { ClientDataCard } from './ClientDataCard';
export { PolicyDataCard } from './PolicyDataCard';
export { CommissionCalculator } from './CommissionCalculator';
export { ConfidenceBadge, ConfidenceBar } from './ConfidenceBadge';

// Default import settings constant
export const DEFAULT_IMPORT_SETTINGS = {
  // Document Management
  autoRename: true,
  fileNameFormat: "{tipo}_{cliente}_{data}",
  splitMultipleDocuments: true,
  saveToLocal: true,
  saveToDrive: true,
  
  // AI Behavior
  autoCalculateBirthDate: true,
  autoCalculateSemiannual: true,
  clientMatching: "ask", // "ask" | "auto" | "always_new"
  minConfidence: 80,
  
  // Required Fields
  requiredFields: {
    clientName: true,
    fiscalCode: false,
    policyNumber: true,
    company: true,
    premium: true,
    licensePlate: false,
  },
  
  // Document Type Mapping
  documentMapping: {
    polizza: "Polizze",
    polizza_veicolo: "Polizze/{TARGA}",
    libretto_circolazione: "Polizze/{TARGA}",
    carta_identita: "Documenti",
    patente: "Documenti",
    tessera_sanitaria: "Documenti",
    codice_fiscale: "Documenti",
    permesso_soggiorno: "Documenti",
    visura_camerale: "Documenti",
    altro: "Documenti"
  }
};
